// src/components/Tenants/Styles/VoiceCallDialog.Style.js
// @flow

const voiceCallDialogStyles = {
  dialogPaper: (theme) => ({
    borderRadius: 2,
    minHeight: 300
  }),

  dialogTitle: (theme) => ({
    textAlign: 'center',
    paddingBottom: theme.spacing(1)
  }),

  contentContainer: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  }),

  avatar: (theme) => ({
    width: 80,
    height: 80,
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.primary.main
  }),

  avatarIcon: (theme) => ({
    fontSize: 48
  }),

  statusContainer: (theme) => ({
    marginTop: theme.spacing(3),
    minHeight: 60,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  }),

  statusBox: (theme) => ({
    textAlign: 'center'
  }),

  callDuration: (theme) => ({
    fontFamily: 'monospace',
    fontWeight: 'bold'
  }),

  controlsContainer: (theme) => ({
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(3),
    marginTop: theme.spacing(3)
  }),

  controlButton: (theme) => ({
    width: 56,
    height: 56
  }),

  muteButton: (theme) => ({
    width: 56,
    height: 56,
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: theme.palette.grey[300]
    }
  }),

  muteButtonActive: (theme) => ({
    width: 56,
    height: 56,
    backgroundColor: theme.palette.error.main,
    color: 'white',
    '&:hover': {
      backgroundColor: theme.palette.error.dark
    }
  }),

  hangupButton: (theme) => ({
    width: 56,
    height: 56,
    backgroundColor: theme.palette.error.main,
    color: 'white',
    '&:hover': {
      backgroundColor: theme.palette.error.dark
    }
  }),

  dialogActions: (theme) => ({
    justifyContent: 'center',
    paddingBottom: theme.spacing(2)
  }),

  pulseIcon: (theme) => ({
    fontSize: 32,
    color: theme.palette.primary.main,
    animation: 'pulse 1.5s infinite'
  }),

  errorText: (theme) => ({
    marginTop: theme.spacing(1)
  }),

  progressSpinner: (theme) => ({
    marginBottom: theme.spacing(1)
  })
};

export default voiceCallDialogStyles;
